import type { PropsWithChildren, ReactNode } from 'react';

import { cn } from '../utils/entry.js';

type CouponEventResultProps = PropsWithChildren<{
  className?: string;
  hasCorrectResult?: boolean;
}>;

/**
 * Component to display the events result in the coupon.
 *
 * @param root0 input object
 * @param root0.children the react nodes to pass down.
 * @param root0.className the classes to apply to the parent
 * @param root0.hasCorrectResult wether or not this result has the correct result.
 * @returns component
 */
export default function CouponEventResult({
  children,
  className,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  hasCorrectResult = false,
}: CouponEventResultProps): ReactNode {
  return <div className={cn('', className)}>{children}</div>;
}
